import React ,{useState,useEffect} from "react";
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { makeStyles } from '@mui/styles';
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {getIndividualProjectStatusList,updateLoginUserName,deleteProjectIndividualStatusRow} from '../function-components/Redux/ProjectMasterSlice';
import {useDispatch, useSelector} from "react-redux";
import Typography from "@mui/material/Typography";
import { useMsal } from "@azure/msal-react";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import './ProjectStatus.css';
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import 'react-datepicker/dist/react-datepicker.css';
import Modal from "@mui/material/Modal";
import { Button } from "@mui/material";
import Grid from '@mui/material/Grid';
import DatePicker from 'react-datepicker';
const baseURL = "https://atcilkm.listracker.accenture.com/listracker-apis";
//const baseURL = "http://localhost:1101";
const ProjectStatus = () => {
const { instance } = useMsal();
const activeAccount = instance.getActiveAccount();
const dispatch = useDispatch();
const username = useSelector((state) => state.projectMaster.username);
const projectStatusList = useSelector((state) => state.projectMaster.projectStatusList);
const [page, setPage] = useState(1);
const PER_PAGE = 6;
const startIdx = (page - 1) * PER_PAGE;
const endIdx = startIdx + PER_PAGE;
const currentItems = projectStatusList.slice(startIdx,  endIdx);
const count = Math.ceil(projectStatusList.length / PER_PAGE);
const [refreshTable, setRefreshTable] = useState(false);
const [statusRefresh, setStatusRefresh] = useState(false);
const [snackbar, setSnackbar] = useState(null);
const [individualDeleteOpen, setIndividualDeleteOpen] = useState(false);
const [individualDeleteRow, setIndividualDeleteRow] = useState("");
const handleCloseSnackbar = () => setSnackbar(null);
const handleChange = (e, p) => {
    setPage(p);
  };


const handleIndividualDeleteClose = () => {
  setIndividualDeleteOpen(false);
  }
const handleIndividualDeleteOpen = () =>{
  setIndividualDeleteOpen(true);
  }  

const handleIndividualDeleteClick = (id) => {
    setIndividualDeleteRow(id);
    handleIndividualDeleteOpen();
  }
  
const handleIndividiualDelete = (e) => {
    e.preventDefault();
    const id = individualDeleteRow.id;
    dispatch(deleteProjectIndividualStatusRow(id));
    handleIndividualDeleteClose();
  };

const theme = createTheme({
        typography: {
        fontFamily: "Graphik-Regular",
        },
        components: {
          MuiInput: {
            styleOverrides: {
              underline: {
                '&:hover:not(.Mui-disabled):before': {
                  borderBottom: 'none !important',
                },
                '&.Mui-focused:after': {
                  borderBottom: 'none !important',
                },
              },
            },
          },
        },
        });
        
const style = {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          border: "2px solid #000",
         };


const useStyles = makeStyles({
          idCell: {
            color: '#7500C0', 
          },
          centeredCell: {
              display: 'flex !important',
              justifyContent: 'center !important',
              alignItems: 'center !important',
            },
        root: {
              '& .MuiDataGrid-cell': {
                border: 'none !important'
              },
              '& .MuiDataGrid-columnHeader': {
                borderBottom: 'none !important'
              }
            },
        });
        
const classes = useStyles();

function StatusDropdown(props) {
const { initialValue, onChange } = props;
const [status, setStatus] = useState(initialValue);
          
          
const getColorForStatus = (statusValue) => {
              switch (statusValue) {
                  case '2':
                    return '#FE7280';
                  case '3':
                    return '#02A873';
                  case '1':
                    return 'blue';
                  case '4':
                    return '#460073';
                  default:
                    return 'black'; // Default color
                 }
                };
                
                
const handleStatusChange = (e) => {
const newStatus = e.target.value;
setStatus(newStatus);
setStatusRefresh(!statusRefresh)
if (onChange) {
onChange(newStatus);
}
}
          
return (
<Select value={status} onChange={handleStatusChange} className="status_dropDown" style={{ color: getColorForStatus(status) }}>
<MenuItem sx={{fontSize:"14px !important"}} value={1}>Yet to Start</MenuItem>
<MenuItem sx={{fontSize:"14px !important"}} value={2}>In Progress</MenuItem>
<MenuItem sx={{fontSize:"14px !important"}} value={3}>Completed</MenuItem>
<MenuItem sx={{fontSize:"14px !important"}} value={4}>New</MenuItem>
</Select>
);
 }

   function handleEndDate(newDate,id) {   
    const formattedDate = newDate.toISOString().split('T')[0];         
    axios.put(`${baseURL}/editProjectStatusList/${id}`,{endDate: formattedDate})
    .then(res => {        
      setSnackbar({ children: 'Data successfully saved', severity: 'success' });
      setRefreshTable(!refreshTable);
    })
    .catch(err => console.log(err))
  }

  function handleStartDate(newDate,id) {
    const formattedDate = newDate.toISOString().split('T')[0];
    axios.put(`${baseURL}/editProjectStatusList/${id}`,{startDate: formattedDate})
    .then(res => {        
      setSnackbar({ children: 'Data successfully saved', severity: 'success' });
      setRefreshTable(!refreshTable);
    })
    .catch(err => console.log(err))
  }

   const columns = [
    {field: 'action', headerName: 'Action', width: 90, filterable: false, 
    renderCell: (params) => {
    return (
      <div className="image_section">
        <img 
          src="/images/projectMaster/delete_icon.png"
          alt="delete" 
          style={{ width: '45%', marginRight:"10px" }}  
          onClick={() => {handleIndividualDeleteClick(params.row.action, params.id); setIndividualDeleteRow(params.row);}}
        />
        <Modal
            // hideBackdrop
            open={individualDeleteOpen}
            onClose={handleIndividualDeleteClose}
            aria-labelledby="modal-modal-title2"
            aria-describedby="modal-modal-description2"
            className="delete-modal"
            >
            <Box sx={style}>
            <div>
            <Grid>
            <div className="modal_header_section">
            <h3 className="form_header">Are you sure you want to delete this row?</h3>
            <span className="form_close_btn_model" 
            onClick={handleIndividualDeleteClose}
            >
              <img
              src="/images/projectMaster/Icon awesome-window-close.png"
              alt="icon"
              className="form_close_img"
              />
            </span>
            </div>
            <div className="del-btn-container">
              <Button
              // type="submit"
              className="yes_button"
              variant="contained"
              onClick={handleIndividiualDelete}
              >
              Yes
              </Button>
              <Button
              // type="submit"
              className="no_button"
              variant="contained"
              //onClick={handleDeleteClose}
              >
              No
              </Button>
            </div>
            </Grid>
          </div>
          </Box>
            </Modal>
        </div>
        )
      }
    },
    { field: 'SerialNo', headerName: 'SL.#', width: 70 },
    {
      field: 'username',
      headerName: 'Enterprise ID',
      width: 150,
      editable: false,
    },
    {
      field: 'requestType',
      headerName: 'Request Type',
      width: 120,
      editable: false,
    },
    {
      field: 'projectName',
      headerName: 'Project Name',
      width: 120,
      editable: false,
      renderCell: (params) => {
        const cellValue = params.value === '' ? 'NA' : params.value;
        return (
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            title={cellValue}
          >
            {cellValue}
          </div>
        );
      },
    },
    {
      field: 'category',
      headerName: 'Category',
      width: 120,
      editable: false,
    },
    {
    field: 'team',
    headerName: 'Team',
    width: 110,
    editable: false,
    },
    {
    field: 'status',
    headerName: 'Status',
    width: 110,
    editable: false,
    renderCell: (params) => {
        return (
          <StatusDropdown 
            initialValue={params.value}
            onChange={(newStatus) => {
            const status = newStatus;
              axios.put(`${baseURL}/editProjectStatusList/${params.id}`,{
                status
                })
                 .then((res)=>{
                  console.log(res.data)
                  setSnackbar({ children: 'Data successfully saved', severity: 'success' });
                  setRefreshTable(!refreshTable);
                 })
                 .catch((err)=>{
                  console.log(err)
                 })
            }}
          />
        );
      },
    },
    {
    field: 'taskType',
    headerName: 'Task Type',
     width: 140,
    editable: false,
    },
    {
    field: 'subTask',
    headerName: 'Sub Task',
    width: 120,
    editable: false,
    renderCell: (params) => {
      const cellValue = params.value || 'NA';
      return (
        <div
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          title={cellValue}
        >
          {cellValue}
        </div>
      );
    },
    },
    {
      field: 'otherTaskType',
      headerName: 'Other Task Type',
       width: 150,
      editable: false,
      renderCell: (params) => {
        const cellValue = params.value === 'select' ? 'NA' : params.value;
        return (
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            title={cellValue}
          >
            {cellValue}
          </div>
        );
      },
    },
    {
    field: 'startDate',
    headerName: 'Start Date',
    width: 120,
    editable: false,
    // renderCell: (params) => {                    
    //     return <input type="date" className="master-list--requested-date" value={params.value} onChange={(e) => handleStartDate(e.target.value,params.id)}/>
    //   }
    renderCell: (params) => {
      const dateValue = params.value ? new Date(params.value) : null;
  
      // Check if dateValue is a valid date
      const isValidDate = !isNaN(dateValue?.getTime());
  
      return (
        <DatePicker
          selected={isValidDate ? dateValue : null}
          onChange={(newDate) => handleStartDate(newDate, params.id)}
          className="master-list--requested-date"
          dateFormat="MM/dd/yyyy"
          placeholderText="MM/DD/YYYY"
          //isClearable
        />
      );
    },
    },
    {
    field: 'endDate',
    headerName: 'End Date',
    width: 120,
    editable: false,
    renderCell: (params) => {
      const dateValue = params.value ? new Date(params.value) : null;
  
      // Check if dateValue is a valid date
      const isValidDate = !isNaN(dateValue?.getTime());
  
      return (
        <DatePicker
          selected={isValidDate ? dateValue : null}
          onChange={(newDate) => handleEndDate(newDate, params.id)}
          className="master-list--requested-date"
          dateFormat="MM/dd/yyyy"
          placeholderText="MM/DD/YYYY"
          //isClearable
        />
      );
    },
    },
    {
    field: 'effort',
    headerName: 'Efforts (in hrs)',
    width: 120,
    editable: true,
    type: 'number',
    cellClassName: `${classes.centeredCell} custom-total-efforts-cell`, 
    // renderCell: (params) => {
    //     return `${params.value} Hours`;
    //   },
    },
    {
    field: 'description',
    headerName: 'Description',
    width: 120,
    editable: true,
    },
]
const rows = currentItems.map((data, i) => ({ ...data, SerialNo: startIdx + i + 1 }));

useEffect(() => {
    dispatch(getIndividualProjectStatusList(username));
  }, [refreshTable,statusRefresh,username]);

  useEffect(() => {
    if (activeAccount) {
     dispatch(updateLoginUserName(activeAccount.idTokenClaims.enterpriseID));
    } else {
     dispatch(updateLoginUserName(null));
    }
   }, [activeAccount]);


  const processRowUpdate = React.useCallback(
    async (newRow) => {
      try {
        const { id, effort, description, projectName, requestType, category } = newRow;
        console.log(newRow,"newrow");
  
        await axios.put(`${baseURL}/editProjectStatusList/${id}`, {
          effort,
          description,
          projectName,
          requestType,
          category
        });
  
        setSnackbar({ children: 'Data successfully saved', severity: 'success' });
        setRefreshTable(!refreshTable);
      } catch (error) {
        console.error('Error updating row:', error);
      }
    },
  );

    return(
        <>
        <ThemeProvider theme={theme}>
        <Box sx={{width:"93.5%",margin:"auto",paddingTop:"30px", paddingBottom:"10px"}}>
        <Typography sx={{fontWeight: "bold", fontSize: "24px"}}>Individual Task Dashboard</Typography>
        </Box>
      <Box sx={{ height: 380, width: '93.5%', margin:'auto' }}>
        <DataGrid className='projectControlTable'
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 6,
              },
            },
          }}
          pageSizeOptions={[6]}
          checkboxSelection={false}
          disableRowSelectionOnClick
          disableColumnSelector={true}
          hideFooterPagination
          processRowUpdate={processRowUpdate}                         
        />
        {!!snackbar && (
        <Snackbar
          open
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          onClose={handleCloseSnackbar}
          autoHideDuration={6000}
        >
          <Alert {...snackbar} onClose={handleCloseSnackbar} />
        </Snackbar>
        )}
        <Stack className="pagination_stack_projectstatus">
          <Pagination count={count} page={page} onChange={handleChange} color="secondary" />
        </Stack>
      </Box>
    </ThemeProvider>
        
        </>
    )
}

export default ProjectStatus;

